import { Box, type Theme, styled } from '@mui/material';
import type { SystemStyleObject } from '@mui/system';

export const DATAGRID_HIDE_SEPARATORS_SX: SystemStyleObject<Theme> = {
  '& .MuiDataGrid-columnSeparator': { display: 'none' },
};

export const DATAGRID_COMPACT_EMPTY_OVERLAY_SX: SystemStyleObject<Theme> = {
  '--DataGrid-overlayHeight': '52px',
};

export const DATAGRID_BORDERED_CONTAINER_SX: SystemStyleObject<Theme> = {
  border: 1,
  borderColor: 'divider',
  borderRadius: 1,
  overflow: 'hidden',
};

export const DATAGRID_EXPAND_TO_ROWS_SX: SystemStyleObject<Theme> = {
  height: 'auto',
  overflow: 'visible',
  '& .MuiDataGrid-main': {
    height: 'auto',
  },
  '& .MuiDataGrid-virtualScroller': {
    height: 'auto',
    overflow: 'hidden',
  },
  '& .MuiDataGrid-virtualScrollerContent': {
    height: 'auto',
  },
  '& .MuiDataGrid-virtualScrollerRenderZone': {
    position: 'static',
  },
};

export const DELETE_ALL_HEADER_BUTTON_SX = {
  justifyContent: 'flex-end',
  minWidth: 0,
  px: 0,
  pr: 0.625,
  width: '100%',
  '& .MuiButton-endIcon': {
    marginLeft: 0.5,
    marginRight: 0,
  },
} as const;

export const SectionStyled = styled(Box)(({ theme }) => ({
  margin: 0,
  padding: theme.spacing(0.5),
}));

export const SectionHeaderStyled = styled(Box)(({ theme }) => ({
  margin: 0,
  padding: theme.spacing(0.5, 1),
  minHeight: 40,
  display: 'flex',
  alignItems: 'center',
}));

export const SectionContentStyled = styled(Box)(({ theme }) => ({
  margin: 0,
  padding: theme.spacing(1),
}));
